import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

class AutoMovingSlidesVertical {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.swiper');

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);
    
    this.reverse = this.dom.el.dataset.reverse;

    this.slider = null;
    this.option = {
      modules: [ Autoplay ],
      direction: 'vertical',
      loop: true,
      slidesPerView: 640 / 180,
      speed: 20000,
      allowTouchMove: false,
      spaceBetween: 0,
      autoplay: {
        delay: 0,
        reverseDirection: (this.reverse == 'true') ? true : false
      },
    };

    this.init();
  }

  init() {
    this.slider = new Swiper(this.dom.slider, this.option);

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');

      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
      
      return;
    } else {
      // console.log('pc');

      if (!this.slider) {
        this.slider = new Swiper(this.dom.slider, this.option);
      }

      return;
		}
	}
}

export default AutoMovingSlidesVertical